import { render, staticRenderFns } from "./search-tabs.vue?vue&type=template&id=18560363&scoped=true&"
import script from "./search-tabs.vue?vue&type=script&lang=js&"
export * from "./search-tabs.vue?vue&type=script&lang=js&"
import style0 from "./search-tabs.vue?vue&type=style&index=0&id=18560363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18560363",
  null
  
)

export default component.exports